import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { motion } from "framer-motion";
import imageUrlBuilder from "@sanity/image-url";
import sanityClient from "../Client";
import Footer from "../components/Footer";
// import * as HiIcons from "react-icons/hi";

const WorkItem = () => {
  const { slug } = useParams();
  const imgBuilder = imageUrlBuilder(sanityClient);
  const [data, setData] = useState(null);

  useEffect(() => {
    sanityClient
      .fetch(
        `*[slug.current == "${slug}"] {
      title,
      _id,
      mainImage{
        asset->{
            _id,
            url
        },
        alt,
      },
      type,
      tagline,
      description,
      images,
      role,
      awards,
      comingSoon,
      link
    }`
      )
      .then((data) => setData(data[0]))
      .catch(console.error);
  }, [slug]);

  const imageUrl = (source) => {
    return imgBuilder.image(source);
  };

  return (
    <>
      <motion.div
        className="work-item"
        initial={{ opacity: 0, z: 100 }}
        animate={{ opacity: 1, z: 0 }}
        exit={{ opacity: 0, z: -100 }}
        transition={{ duration: 1, delay: 0.5 }}
      >
        <div className="work-item-top">
          <div className="work-item-top-left">
            <motion.span
              initial={{
                opacity: 0,
                transform: "scale(1.01)",
              }}
              whileInView={{
                opacity: 1,
                transform: "scale(1.02)",
              }}
              transition={{ duration: 0.25, delay: 0.1 }}
            >
              {data?.type}
            </motion.span>
            <motion.h2
              initial={{
                opacity: 0,
                transform: "scale(1.01)",
              }}
              whileInView={{
                opacity: 1,
                transform: "scale(1.02)",
              }}
              transition={{ duration: 0.25, delay: 0.1 }}
            >
              {data?.title}
            </motion.h2>
            <motion.p
              initial={{
                opacity: 0,
                transform: "scale(1.01)",
              }}
              whileInView={{
                opacity: 1,
                transform: "scale(1.02)",
              }}
              transition={{ duration: 0.25, delay: 0.1 }}
            >
              {data?.description}
            </motion.p>
          </div>
          <div className="work-item-top-right">
            <motion.span
              initial={{
                opacity: 0,
                transform: "scale(1.01)",
              }}
              whileInView={{
                opacity: 1,
                transform: "scale(1.02)",
              }}
              transition={{ duration: 0.25, delay: 0.1 }}
            >
              Role
            </motion.span>
            <motion.p
              initial={{
                opacity: 0,
                transform: "scale(1.01)",
              }}
              whileInView={{
                opacity: 1,
                transform: "scale(1.02)",
              }}
              transition={{ duration: 0.25, delay: 0.1 }}
            >
              {data?.role}
            </motion.p>
          </div>
        </div>
        <motion.div className="work-item-image-container">
          <motion.div className="work-item-image">
            {data?.images?.map((item, index) => (
              <motion.img
                key={index}
                className="is-reveal"
                src={imageUrl(item).url()}
                alt=""
                initial={{
                  opacity: 0.5,
                  transform: "scale(1.01)",
                }}
                whileInView={{
                  opacity: 1,
                  transform: "scale(1.02)",
                }}
                transition={{ duration: 0.25, delay: 0.1 }}
              />
            ))}
          </motion.div>
        </motion.div>
      </motion.div>
      <motion.div
        className="page-bottom-sections"
        initial={{
          opacity: 0.75,
          clipPath: "polygon(0% 100%, 100% 100%, 100% 100%, 0% 100%)",
        }}
        whileInView={{
          opacity: 1,
          clipPath: "polygon(0% 100%, 100% 100%, 100% 0%, 0% 0%)",
        }}
        transition={{ duration: 0.5 }}
      >
        <Footer />
      </motion.div>
    </>
  );
};

export default WorkItem;
